export const PERMISSIONS = Object.freeze({
  APP: {
    VIEW: 'APP.VIEW',
  },
  ROLES: {
    VIEW: 'ROLES.VIEW',
    CREATE: 'ROLES.CREATE',
    UPDATE: 'ROLES.UPDATE',
    EDIT: 'ROLES.EDIT',
    DELETE: 'ROLES.DELETE',
    SYNC: 'ROLES.SYNC',
  },
  USERS: {
    VIEW: 'USERS.VIEW',
    CREATE: 'USERS.CREATE',
    UPDATE: 'USERS.UPDATE',
    EDIT: 'USERS.EDIT',
    DELETE: 'USERS.DELETE',
    GET_PERMISSION: 'USERS.GET_PERMISSION',
    SYNC: 'USERS.SYNC',
  },
  MENU_ITEMS: {
    CREATE: 'MENU_ITEMS.CREATE',
    EDIT: 'MENU_ITEMS.EDIT',
    VIEW: 'MENU_ITEMS.VIEW',
    REMOVE: 'MENU_ITEMS.REMOVE',
    VIEW_INACTIVE: 'MENU_ITEMS.VIEW_INACTIVE',
    VIEW_INACTIVE_PAGE: 'MENU_ITEMS.VIEW_INACTIVE_PAGE',
  },
  PERMISSIONS: {
    VIEW: 'PERMISSIONS.VIEW',
    CREATE: 'PERMISSIONS.CREATE',
    EDIT: 'PERMISSIONS.EDIT',
    DELETE: 'PERMISSIONS.DELETE',
    SYNC: 'PERMISSIONS.SYNC',
    GET_LIST_APP: 'PERMISSIONS.GET_LIST_APP',
    GET_ALL: 'PERMISSIONS.GET_ALL',
  },
  CENTRES: {
    VIEW: 'CENTERS.VIEW',
    CREATE: 'CENTERS.CREATE',
    EDIT: 'CENTERS.EDIT',
    DELETE: 'CENTERS.DELETE',
  },
  BUSINESS_UNITS: {
    VIEW: 'BUSINESS_UNITS.VIEW',
    CREATE: 'BUSINESS_UNITS.CREATE',
    EDIT: 'BUSINESS_UNITS.EDIT',
    DELETE: 'BUSINESS_UNITS.DELETE',
    DEACTIVATE: 'BUSINESS_UNITS.DEACTIVATE',
  },
  COURSE_LINES: {
    VIEW: 'COURSE_LINES.VIEW',
    CREATE: 'COURSE_LINES.CREATE',
    EDIT: 'COURSE_LINES.EDIT',
    DELETE: 'COURSE_LINES.DELETE',
  },
  COURSE: {
    VIEW: 'COURSE.VIEW',
    CREATE: 'COURSE.CREATE',
    EDIT: 'COURSE.EDIT',
    DELETE: 'COURSE.DELETE',
  },
  COURSE_TOPIC: {
    VIEW: 'COURSE_TOPIC.VIEW',
    CREATE: 'COURSE_TOPIC.CREATE',
    EDIT: 'COURSE_TOPIC.EDIT',
    DELETE: 'COURSE_TOPIC.DELETE',
  },
  COUNTRIES: {
    VIEW: 'COUNTRIES.VIEW',
    CREATE: 'COUNTRIES.CREATE',
    EDIT: 'COUNTRIES.EDIT',
  },
  CITIES: {
    VIEW: 'CITIES.VIEW',
    CREATE: 'CITIES.CREATE',
    EDIT: 'CITIES.EDIT',
  },
  DISTRICTS: {
    VIEW: 'DISTRICTS.VIEW',
    CREATE: 'DISTRICTS.CREATE',
    EDIT: 'DISTRICTS.EDIT',
  },
  WARDS: {
    VIEW: 'WARDS.VIEW',
    CREATE: 'WARDS.CREATE',
    EDIT: 'WARDS.EDIT',
  },
  EMPLOYEE: {
    VIEW: 'EMPLOYEE.VIEW',
    IMPORT: 'EMPLOYEE.IMPORT',
  },
  BUSINESS_PARAMETER: {
    VIEW: 'BUSINESS_PARAMETER.VIEW',
    CREATE: 'BUSINESS_PARAMETER.CREATE',
    EDIT: 'BUSINESS_PARAMETER.EDIT',
  },
  PRODUCT_LINE: {
    VIEW: 'PRODUCT_LINE.VIEW',
    CREATE: 'PRODUCT_LINE.CREATE',
    EDIT: 'PRODUCT_LINE.EDIT',
    DELETE: 'PRODUCT_LINE.DELETE',
  },
  SALES_TARGET_RANK: {
    VIEW: 'SALES_TARGET_RANK.VIEW',
    CREATE: 'SALES_TARGET_RANK.CREATE',
    EDIT: 'SALES_TARGET_RANK.EDIT',
    DELETE: 'SALES_TARGET_RANK.DELETE',
  },
});
